module.exports = __webpack_public_path__ + "379edfd54a31ca6134b2478f3f2c793f.pdf";